import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, Children, cloneElement } from 'react';
import mitt from 'mitt';
import Popover from '../Popover';
import { composeEvents, pageViewChange } from '../utils';
var emitter = mitt();
var globalTimeoutId = null;
var instantDelay = false;

function startGlobalTimeout() {
  instantDelay = true;
  globalTimeoutId = setTimeout(function () {
    instantDelay = false;
  }, 500);
}

function clearGlobalTimeout() {
  clearTimeout(globalTimeoutId);
}

var Tooltip = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tooltip, _Component);

  function Tooltip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isPopoverOpen: _this.props.defaultOpen
    });

    _defineProperty(_assertThisInitialized(_this), "isPageInView", true);

    _defineProperty(_assertThisInitialized(_this), "isFocused", false);

    _defineProperty(_assertThisInitialized(_this), "isMouseDown", false);

    _defineProperty(_assertThisInitialized(_this), "openTimeoutId", null);

    _defineProperty(_assertThisInitialized(_this), "closeTimeoutId", null);

    _defineProperty(_assertThisInitialized(_this), "cleanupPageViewChange", pageViewChange(function (inView) {
      return setTimeout(function () {
        return _this.isPageInView = inView;
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "handleCloseOpenTooltips", function (instance) {
      if (_assertThisInitialized(_this) !== instance) {
        _this.close();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createOpenTimeout", function () {
      clearGlobalTimeout();

      if (_this.openTimeoutId === null) {
        clearTimeout(_this.closeTimeoutId);
        _this.closeTimeoutId = null;

        if (_this.state.isPopoverOpen === false) {
          emitter.emit('CLOSE_OPEN_TOOLTIPS');
          _this.openTimeoutId = setTimeout(function () {
            return _this.open();
          }, instantDelay ? 0 : _this.props.openDelay);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "createCloseTimeout", function () {
      startGlobalTimeout();

      if (_this.closeTimeoutId === null) {
        clearTimeout(_this.openTimeoutId);
        _this.openTimeoutId = null;
        _this.closeTimeoutId = setTimeout(function () {
          _this.close();
        }, _this.props.closeDelay);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      clearTimeout(_this.closeTimeoutId);
      _this.closeTimeoutId = null;

      _this.setState({
        isPopoverOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      clearTimeout(_this.openTimeoutId);
      _this.openTimeoutId = null;

      _this.setState({
        isPopoverOpen: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      _this.setState(function (state) {
        return {
          isPopoverOpen: !state.isPopoverOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      if (_this.isPageInView && !_this.isMouseDown) {
        _this.open();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function () {
      _this.isMouseDown = true;

      _this.close();
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function () {
      _this.isMouseDown = false;
    });

    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentDidMount = function componentDidMount() {
    emitter.on('CLOSE_OPEN_TOOLTIPS', this.handleCloseOpenTooltips);
  };

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.triggerOnFocus !== this.props.triggerOnFocus && this.props.triggerOnFocus === false || lastProps.triggerOnHover !== this.props.triggerOnHover && this.triggerOnHover === false) {
      this.close();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    emitter.off('CLOSE_OPEN_TOOLTIPS', this.handleCloseOpenTooltips);
    clearTimeout(this.openTimeoutId);
    clearTimeout(this.closeTimeoutId);
    this.cleanupPageViewChange();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        openDelay = _this$props.openDelay,
        closeDelay = _this$props.closeDelay,
        defaultOpen = _this$props.defaultOpen,
        keepInView = _this$props.keepInView,
        placement = _this$props.placement,
        popoverProps = _this$props.popoverProps,
        renderTo = _this$props.renderTo,
        title = _this$props.title,
        triggerOnFocus = _this$props.triggerOnFocus,
        triggerOnHover = _this$props.triggerOnHover,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "openDelay", "closeDelay", "defaultOpen", "keepInView", "placement", "popoverProps", "renderTo", "title", "triggerOnFocus", "triggerOnHover"]);

    var isPopoverOpen = this.state.isPopoverOpen;
    var child = Children.only(children);
    var _child$props = child.props,
        onFocus = _child$props.onFocus,
        onBlur = _child$props.onBlur,
        onMouseEnter = _child$props.onMouseEnter,
        onMouseLeave = _child$props.onMouseLeave,
        onMouseDown = _child$props.onMouseDown,
        onMouseUp = _child$props.onMouseUp;

    if (!title) {
      return /*#__PURE__*/cloneElement(child, childProps);
    }

    if (triggerOnFocus) {
      childProps.onFocus = composeEvents(this.handleFocus, onFocus);
      childProps.onBlur = composeEvents(this.close, onBlur);
      childProps.onMouseDown = composeEvents(this.handleMouseDown, onMouseDown);
      childProps.onMouseUp = composeEvents(this.handleMouseUp, onMouseUp);
    }

    if (triggerOnHover) {
      childProps.onMouseEnter = composeEvents(this.createOpenTimeout, onMouseEnter);
      childProps.onMouseLeave = composeEvents(this.createCloseTimeout, onMouseLeave);
    }

    return /*#__PURE__*/React.createElement(Popover, _extends({
      shouldFlip: true,
      paddingHorizontal: 0.75,
      paddingVertical: 0.25,
      fontSize: 5,
      textAlign: "center",
      radius: 2,
      backgroundColor: "grey-9",
      color: "rgba(255,255,255,0.94)",
      zIndex: 9999
    }, popoverProps, {
      anchorElement: /*#__PURE__*/cloneElement(child, childProps),
      onMouseEnter: this.createOpenTimeout,
      onMouseLeave: this.createCloseTimeout,
      keepInView: keepInView,
      placement: placement,
      renderTo: renderTo,
      children: title,
      open: isPopoverOpen
    }));
  };

  return Tooltip;
}(Component);

_defineProperty(Tooltip, "defaultProps", {
  openDelay: 500,
  closeDelay: 300,
  keepInView: true,
  triggerOnFocus: true,
  triggerOnHover: true,
  defaultOpen: false
});

export default Tooltip;